export enum ScaleConnection {
  SERIAL = "RS-232 Serial Port",
  ETHERNET = "Ethernet"
}
